export const filtersInitialState = {
  aeroportos: [],
};
